import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { PrivateRoute } from './components/PrivateRoute';
import { HomePage } from './HomePage';
import { LoginPage } from './LoginPage';
import Wholesalertools from './components/Wholesaler/Tools';
import Admintools from './components/Admin/Tools';
import Wholesalerpayment from './components/Wholesaler/Payment';
import DistributorTools from './components/Distributor/Tools';
import WholesalerReports from './components/Wholesaler/Reports';
import Analytics from './components/Wholesaler/Analytics';
import WhGeographic from './components/Wholesaler/Geographic';
import WhPharmacies from './components/Wholesaler/Pharmacies';
import Analyticsa from './components/Admin/Analytics';
import AdGeographic from './components/Admin/Geographic';
import AdPharmacies from './components/Admin/Pharmacies';
import AdPublicAPI from './components/Admin/PublicAPI';
import AdminReports from './components/Admin/Reports';
import ResetPassword from './components/ResetPassword';
import PasswordChangedSuccessfully from './components/PasswordChanged';
import AdvanceFilter from './components/AdvanceFilter';
import PageNotFound from './components/PageNotFound';
import { Helmet } from "react-helmet";
import * as signalR from '@aspnet/signalr';
import { userService } from './_services';
import CompanyOverview from './components/Admin/CompanyOverview';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr/dist/browser/signalr.min.js';
//import { HubConnection, HubConnectionBuilder } from "@aspnet/signalr";

//window.jQuery = $;
//require('signalr');
//import { version } from ".././package.json";
// import withClearCache from "./ClearCache";
import { getBuildDate } from "./utils";
//import CacheBuster from 'react-cache-buster';

export default class App extends Component {
    static displayName = App.name;
    constructor(props) {
        super(props);

        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            message: '',
            messages: [],
            hubConnection: null,
            bookingMessage: '',
            bookingHubConnection: null
        };
    }
    componentDidMount = () => {
        //var connection = new signalR.HubConnectionBuilder().withUrl("/fuser").build();
        //try {
        //    connection.start().then(() => {
        //        connection.on("ReceiveMessage", function (whemail, status) {
        //            if (localstoragedata != '' && localstoragedata != null && localstoragedata != undefined && localstoragedata != '{}' && localstoragedata.userrole.toLowerCase() == 'wholesaler') {
        //                if (this.state.userdata.email == whemail && this.state.userdata.isfu != status) {

        //                }
        //            }
        //        });
        //    });
        //}
        //catch (err) {
        //}
        //connection.on("ReceiveMessage", function (WhId, Email) {
        //    debugger;
        //    console.log(WhId + '-' + Email + '-Did Mount');
        //});
        try {
            const favicon = this.getFaviconEl();
            if (window.location.hostname.split('.')[1] == 'glichealth' && window.location.host.toLowerCase() != "tempfilter.glichealth.com")
                favicon.href = "/glicrx_favicon.ico";
            else if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter.glichealth.com") {
                favicon.href = "/Rxhacker_favicon_new.ico";
            }
            else
                favicon.href = "/Rxhacker_favicon_new.ico";
        }
        catch (err) {
        }
    }
    getFaviconEl() {
        return document.getElementById("favicon");
    }
    componentDidUpdate = () => {
        var connection = new signalR.HubConnectionBuilder().withUrl("/fuser").build();
        try {
            connection.start().then(() => {
                connection.on("ReceiveMessage", function (whid, fuseremail) {
                });
            });
        }
        catch (err) {
        }
    }
    setPageTitle() {
        var PageTitle = 'Reporting Dashboard';
        try {
            if (userService.Check_LoggedIn_Status() != 'Login') {
                switch (window.location.pathname) {
                    case '/filter':
                        PageTitle = 'Filter';
                        break;
                    case '/filter/':
                        PageTitle = 'Filter';
                        break;
                    case '/admin/report':
                        PageTitle = 'Reports';
                        break;
                    case '/admin/report/':
                        PageTitle = 'Reports';
                        break;
                    case '/wholesaler/report':
                        PageTitle = 'Reports';
                        break;
                    case '/wholesaler/report/':
                        PageTitle = 'Reports';
                        break;
                    case '/admin/tools':
                        PageTitle = 'Tools';
                        break;
                    case '/admin/tools/':
                        PageTitle = 'Tools';
                        break;
                    case '/wholesaler/tools':
                        PageTitle = 'Tools';
                        break;
                    case '/wholesaler/tools/':
                        PageTitle = 'Tools';
                        break;
                    case '/wholesaler/payment':
                        PageTitle = 'Payments';
                        break;
                    case '/wholesaler/payment/':
                        PageTitle = 'Payments';
                        break;
                    case '/distributor/tools':
                        PageTitle = 'Tools';
                        break;
                    case '/distributor/tools/':
                        PageTitle = 'Tools';
                        break;
                    case '/dashboard':
                        PageTitle = 'Dashboard';
                        break;
                    case '/dashboard/':
                        PageTitle = 'Dashboard';
                        break;
                    case '/wholesaler/analytics/signups':
                        PageTitle = 'Signups';
                        break;
                    case '/wholesaler/analytics/signups/':
                        PageTitle = 'Signups';
                        break;
                    case '/wholesaler/analytics/geographic':
                        PageTitle = 'Geographic';
                        break;
                    case '/wholesaler/analytics/geographic/':
                        PageTitle = 'Geographic';
                        break;
                    case '/wholesaler/analytics/pharmacies':
                        PageTitle = 'Pharmacies';
                        break;
                    case '/wholesaler/analytics/pharmacies/':
                        PageTitle = 'Pharmacies';
                        break;
                    case '/admin/analytics/signups':
                        PageTitle = 'Signups';
                        break;
                    case '/admin/analytics/signups/':
                        PageTitle = 'Signups';
                        break;
                    case '/admin/analytics/geographic':
                        PageTitle = 'Geographic';
                        break;
                    case '/admin/analytics/geographic/':
                        PageTitle = 'Geographic';
                        break;
                    case '/admin/analytics/pharmacies':
                        PageTitle = 'Pharmacies';
                        break;
                    case '/admin/analytics/publicapi':
                        PageTitle = 'Public API';
                        break;
                    case '/admin/analytics/pharmacies/':
                        PageTitle = 'Pharmacies';
                        break;
                    case '/login':
                        PageTitle = 'Dashboard Login';
                        break;
                    case '/':
                        PageTitle = 'Dashboard Login';
                        break;
                    case '/login/':
                        PageTitle = 'Dashboard Login';
                        break;
                    case '/resetPassword':
                        PageTitle = 'Reset Password Page';
                        break;
                    case '/passwordChanged':
                        PageTitle = 'Change Password Page';
                        break;
                    case '/admin/companyOverview/':
                        PageTitle = 'Company Overview';
                        break;
                    case '/admin/companyOverview':
                        PageTitle = 'Company Overview';
                        break;
                    default:
                        PageTitle = 'Page Not Found';
                        break;
                }
            } else {
                switch (window.location.pathname) {
                    case '/filter':
                        PageTitle = 'Filter';
                        break;
                    case '/filter/':
                        PageTitle = 'Filter';
                        break;
                    case '/admin/report':
                        PageTitle = 'Reports';
                        break;
                    case '/admin/report/':
                        PageTitle = 'Reports';
                        break;
                    case '/wholesaler/report':
                        PageTitle = 'Reports';
                        break;
                    case '/wholesaler/report/':
                        PageTitle = 'Reports';
                        break;
                    case '/admin/tools':
                        PageTitle = 'Tools';
                        break;
                    case '/admin/tools/':
                        PageTitle = 'Tools';
                        break;
                    case '/wholesaler/tools':
                        PageTitle = 'Tools';
                        break;
                    case '/wholesaler/tools/':
                        PageTitle = 'Tools';
                        break;
                    case '/wholesaler/payment':
                        PageTitle = 'Payments';
                        break;
                    case '/wholesaler/payment/':
                        PageTitle = 'Payments';
                        break;
                    case '/distributor/tools':
                        PageTitle = 'Tools';
                        break;
                    case '/distributor/tools/':
                        PageTitle = 'Tools';
                        break;
                    case '/dashboard':
                        PageTitle = 'Dashboard';
                        break;
                    case '/dashboard/':
                        PageTitle = 'Dashboard';
                        break;
                    case '/wholesaler/analytics/signups':
                        PageTitle = 'Signups';
                        break;
                    case '/wholesaler/analytics/signups/':
                        PageTitle = 'Signups';
                        break;
                    case '/wholesaler/analytics/geographic':
                        PageTitle = 'Geographic';
                        break;
                    case '/wholesaler/analytics/geographic/':
                        PageTitle = 'Geographic';
                        break;
                    case '/wholesaler/analytics/pharmacies':
                        PageTitle = 'Pharmacies';
                        break;
                    case '/wholesaler/analytics/pharmacies/':
                        PageTitle = 'Pharmacies';
                        break;
                    case '/admin/analytics/signups':
                        PageTitle = 'Signups';
                        break;
                    case '/admin/analytics/signups/':
                        PageTitle = 'Signups';
                        break;
                    case '/admin/analytics/geographic':
                        PageTitle = 'Geographic';
                        break;
                    case '/admin/analytics/geographic/':
                        PageTitle = 'Geographic';
                        break;
                    case '/admin/analytics/pharmacies':
                        PageTitle = 'Pharmacies';
                        break;
                    case '/admin/analytics/pharmacies/':
                        PageTitle = 'Pharmacies';
                        break;
                    case '/admin/analytics/publicapi':
                        PageTitle = 'Public API';
                        break;
                    case '/login':
                        PageTitle = 'Dashboard Login';
                        break;
                    case '/':
                        PageTitle = 'Reporting Dashboard';
                        break;
                    case '/login/':
                        PageTitle = 'Dashboard Login';
                        break;
                    case '/resetPassword':
                        PageTitle = 'Reset Password Page';
                        break;
                    case '/passwordChanged':
                        PageTitle = 'Change Password Page';
                        break;
                    case '/admin/companyOverview/':
                        PageTitle = 'Company Overview';
                        break;
                    case '/admin/companyOverview':
                        PageTitle = 'Company Overview';
                        break;
                    default:
                        PageTitle = 'Page Not Found';
                        break;
                }
            }
        }
        catch (error) { }
        return PageTitle;
    }
    /*
    MainApp(props) {
        return (
            <div>
                <p>Build date: {getBuildDate(packageJson.buildDate)}</p>
            </div>
        );
    }*/

    render() {
        // withClearCache(this.MainApp);
        let pt = this.setPageTitle();
        let local_live = window.location.host.split('.').slice(-2).join('.').toLowerCase();
        let domainURL = 'localhost:5464';
        if (local_live === 'localhost:5464')
            domainURL = 'localhost:5464';
        else
            domainURL = 'glichealth.com';
        const isLocal = window.location.host.split('.').slice(-2).join('.').toLowerCase() === domainURL;

        return (
            <div className="jumbotron">
                <div className="container">
                    <div className="col-sm-8 col-sm-offset-2">
                        <Helmet>
                            <title>{pt}</title>
                            <meta name="viewport" content="width=device-width, initial-scale=1" shrink-to-fit="yes" />
                        </Helmet>
                        <Router>
                            <div>
                                <Switch>
                                    <PrivateRoute exact="true" path="/" component={HomePage} title="Dashboard Page" />
                                    <Route exact="true" path="/login" component={LoginPage} title="Login Page" />
                                    <Route exact="true" path="/dashboard" component={HomePage} title="Dashboard Page" />
                                    <Route exact="true" path="/wholesaler/tools" component={Wholesalertools} title="Tools Page" />
                                    <Route exact="true" path="/wholesaler/payment" component={Wholesalerpayment} title="Payment Page" />
                                    <Route exact="true" path="/wholesaler/analytics/signups" component={Analytics} title="Signups" />
                                    <Route exact="true" path="/wholesaler/analytics/geographic" component={WhGeographic} title="Geographic" />
                                    <Route exact="true" path="/wholesaler/analytics/pharmacies" component={WhPharmacies} title="Pharmacies" />
                                    <Route exact="true" path="/admin/analytics/signups" component={Analyticsa} title="Signups" />
                                    <Route exact="true" path="/admin/analytics/geographic" component={AdGeographic} title="Geographic" />
                                    <Route exact="true" path="/admin/analytics/pharmacies" component={AdPharmacies} title="Pharmacies" />
                                    <Route exact="true" path="/admin/analytics/publicapi" component={AdPublicAPI} title="Public API" />
                                    <Route exact="true" path="/admin/tools" component={Admintools} title="Tools Page" />
                                    <Route exact="true" path="/distributor/tools" component={DistributorTools} title="Tools Page" />
                                    <Route exact="true" path="/wholesaler/report" component={WholesalerReports} title="Reports Page" />
                                    <Route exact="true" path="/admin/report" component={AdminReports} title="Reports Page" />
                                    <Route exact="true" path="/resetPassword" component={ResetPassword} title="Reset Password Page" />
                                    <Route exact="true" path="/passwordChanged" component={PasswordChangedSuccessfully} title="Change Password Page" />
                                    <Route exact="true" path="/filter" component={AdvanceFilter} title="Filter Page" />
                                    <Route exact="true" path="/pageNotFound" component={PageNotFound} title="Page Not Found" />
                                    <Route exact="true" path="/admin/companyOverview" component={CompanyOverview} title="Company Overview Page" />
                                    <Route path="*" component={PageNotFound} title="Page Not Found" />
                                </Switch>
                            </div>
                        </Router>
                    </div>
                </div>
            </div>
        );
    }
}